import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '../../../../base';
import { IChartTooltipProps } from '../../../../common';

const JobMetricChartTooltip = ({ active, payload }: IChartTooltipProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (!active || !payload?.length) return null;

    const days = Math.round(payload[0].value);

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.grey[800],
                color: theme.palette.common.white,
                padding: theme.spacing(0.5, 1.5),
                borderRadius: 1.5,
            }}
        >
            <Typography variant="caption">
                {`${days} ${t('reportsPage.timeToHireReport.days')}`}
            </Typography>
        </Box>
    );
};

export default JobMetricChartTooltip;
